<template>
  <document-element-fill
    v-model="snippetInsert.documentElement"
    v-if="snippetInsert.documentElement"
  />
</template>

<script>
export default {
  name: "SnippetInsert",
  props: ["snippetInsert"]
};
</script>